import { constantRoutes } from '@/router'
import { listMenu } from '@/api/menu'
import Layout from '@/layout'

const importFn = require.context('./../../views', true, /\.vue$/)
const modules = {}
importFn.keys().forEach(item => {
  // 注意: 这里需要 .default才可以找到路径const com = importFn(item).default
  modules[item.replace('./', '').split('.vue')[0]] = importFn(item).default
})

const loadView = (view) => {
  let res
  for (const path in modules) {
    if (path === view) {
      res = modules[path]
    }
  }
  return res
}

/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
function hasPermission(authorization, route) {
  console.log(authorization, route)
  if (route.meta && route.meta.auth) {
    return authorization.some(auth => {
      return route.meta.auth.some(routeAuth => {
        return routeAuth === auth
      })
    })
  } else {
    return false
  }
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param routes asyncRoutes
 * @param roles
 */
function filterAsyncRoutes(routes, authorization) {
  const res = []
  routes.forEach(route => {
    const tmp = { ...route }
    if (tmp.children) {
      tmp.children = filterAsyncRoutes(tmp.children, authorization)
    }
    if (hasPermission(authorization, tmp) || (tmp.children && tmp.children.length > 0)) {
      res.push(tmp)
    }
  })
  return res
}

function transformRoutes(menus) {
  function helper(menus, level) {
    return menus.filter(i => i.type !== 'F').map(menu => {
      const m = {
        id: menu.id,
        parent_id: menu.parent_id,
        type: menu.type,
        path: menu.route_url,
        component: Layout,
        name: `${menu.route_url}_${menu.type}`,
        meta: {
          title: menu.name,
          icon: menu.icon
        },
        hidden: menu.show_status === 0,
        children: helper(menu.children ? menu.children : [], level + 1),
        query: menu.route_params
      }

      if (menu.perms) {
        m.meta.auth = [menu.perms]
      }

      if (level === 0) {
        m.path = '/' + m.path
      }

      if (menu.component_path) {
        // Layout ParentView 组件特殊处理
        if (menu.type === 'M') {
          m.component = Layout
        } else {
          m.component = loadView(menu.component_path)
        }
      }

      return m
    })
  }

  menus = helper(menus, 0)
  return menus
}

// /**
//  * 递归过滤服务端返回的路由表，映射其中的component
//  * @param routes asyncRoutes
//  * @param roles
//  */
// function generateAsyncRoutes(routerMap, serverMap) {
//   const arr = []
//   serverMap.forEach(function(item, index) {
//     const route = {}
//     route.meta = { icon: item.icon, title: item.title }
//     route.path = item.url || ('noroute/' + createUniqueString())
//     route.name = item.name
//     route.hidden = !item.is_menu
//     if (item.children && item.children.length > 0) {
//       route.component = routerMap['Layout']
//       route.children = generateAsyncRoutes(routerMap, item.children)
//       arr.push(route)
//     } else { // 不存在子节点
//       if (routerMap[item.name]) {
//         const { path, component } = routerMap[item.name]
//         route.path = item.url || path
//         route.component = component
//         arr.push(route)
//       }
//     }
//   })
//   return arr
// }

/**
 * 递归过滤服务端返回的路由表，映射其中的component
 * @param routes asyncRoutes
 * @param roles
 */

const state = {
  routes: [],
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  }
}

const actions = {
  generateRoutes({ rootState, commit, dispatch }) {
    return listMenu().then(async data => {
      const asyncRoutes = transformRoutes(data.data)
      let accessedRoutes
      if (rootState.user.is_system === 0) {
        const permissions = await dispatch('user/getPermissions', null, { root: true })
        accessedRoutes = filterAsyncRoutes(asyncRoutes, permissions)
      } else {
        accessedRoutes = asyncRoutes
      }
      commit('SET_ROUTES', accessedRoutes)
      console.log('accessedRoutes', accessedRoutes)
      return accessedRoutes
    })
    // return new Promise(async(resolve, reject) => {
    //   let accessedRoutes
    //   if (rootState.user.is_system === 0) {
    //     const permissions = await dispatch('user/getPermissions', null, { root: true })
    //     accessedRoutes = filterAsyncRoutes(asyncRoutes, permissions)

    //     console.log('accessedRoutes', accessedRoutes)
    //   } else {
    //     accessedRoutes = asyncRoutes
    //   }
    //   commit('SET_ROUTES', accessedRoutes)
    //   resolve(accessedRoutes)
    // })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
